import { autocompleteClasses, styled } from '@mui/material';

const StyledAutocompletePopper = styled('div')(({ theme }) => ({
  width: '100%!important',
  [`& .${autocompleteClasses.listbox}`]: {
    padding: 0,
    backgroundColor: theme.palette.background.primaryAlt,
    [`& .${autocompleteClasses.option}`]: {
      minHeight: 'auto',
      alignItems: 'flex-start',
      [`&.${autocompleteClasses.focused}, &.${autocompleteClasses.focused}[aria-selected="true"]`]:
        {
          backgroundColor: theme.palette.action.hover,
        },
    },
  },
  [`&.${autocompleteClasses.popperDisablePortal}`]: {
    position: 'relative',
  },
}));

export default StyledAutocompletePopper;
